<!--  -->
<template>
  <div class="main_w">
    <CellGroup title="平台规则">
      <Cell
        title="神州邦邦工程师平台服务规范"
        is-link
        :to="{ name: 'ruleDetail', query: { id: '1' } }"
      />
      <Cell
        title="神州邦邦平台工程师管理规则"
        is-link
        :to="{ name: 'ruleDetail', query: { id: '2' } }"
      />
      <Cell
        title="神州邦邦用户账号使用规范"
        is-link
        :to="{ name: 'ruleDetail', query: { id: '3' } }"
      />
      <Cell
        title="神州邦邦平台诚信保证金规则"
        is-link
        :to="{ name: 'ruleDetail', query: { id: '4' } }"
      />
      <Cell
        title="神州邦邦平台发票开具规则"
        is-link
        :to="{ name: 'ruleDetail', query: { id: '5' } }"
      />
      <Cell
        title="神州邦邦平台发票收取规则"
        is-link
        :to="{ name: 'ruleDetail', query: { id: '6' } }"
      />
      <Cell
        title="神州邦邦平台纠纷处理规则"
        is-link
        :to="{ name: 'ruleDetail', query: { id: '7' } }"
      />
      <Cell
        title="神州邦邦平台侵权处理规则"
        is-link
        :to="{ name: 'ruleDetail', query: { id: '8' } }"
      />
      <Cell
        title="神州邦邦平台交易评价规则"
        is-link
        :to="{ name: 'ruleDetail', query: { id: '9' } }"
      />
      <Cell
        title="神州邦邦招聘职位信息发布规则"
        is-link
        :to="{ name: 'ruleDetail', query: { id: '10' } }"
      />
    </CellGroup>
    <CellGroup title="平台协议">
      <Cell title="神州邦邦用户注册服务协议" is-link :url="url1" />
      <!-- <Cell title="神州邦邦隐私政策" is-link :url="url2" /> -->
      <Cell
        title="神州邦邦隐私政策"
        is-link
        :to="{ name: 'ruleDetail', query: { id: '14' } }"
      />
      <Cell
        title="神州邦邦平台服务协议"
        is-link
        :to="{ name: 'ruleDetail', query: { id: '11' } }"
      />
      <Cell
        title="平台广告发布协议"
        is-link
        :to="{ name: 'ruleDetail', query: { id: '12' } }"
      />
      <Cell
        title="用户数据授权协议"
        is-link
        :to="{ name: 'ruleDetail', query: { id: '13' } }"
      />
      <Cell title="神州邦邦商城使用协议" is-link :url="liteMallAgreement" />
      <Cell
        title="营业执照"
        is-link
        :url="`${publicPath}pdf/web/viewer.html?file=北京邦邦营业执照-20230404版.pdf`"
      />
      <Cell
        title="人力资源许可证"
        is-link
        :url="`${publicPath}pdf/web/viewer.html?file=人力资源服务许可证.pdf`"
      />
    </CellGroup>
  </div>
</template>

<script>
import basePage from "@/pages/basePage.vue";
import { Cell, CellGroup, Col, Row, Collapse, CollapseItem, Icon } from "vant";
import { h5 } from "@/utils/env";
export default {
  extends: basePage,
  //import引入的组件需要注入到对象中才能使用
  components: {
    Cell,
    CellGroup,
    Col,
    Row,
    Collapse,
    CollapseItem,
    Icon,
  },
  data() {
    //这里存放数据
    return {
      url1: `${h5}app/register/register_e.html`,
      url2: `https://c.shenzhoubb.com/article/1575881359388`,
      liteMallAgreement: `${h5}app/v2/agreement/liteMall.html`,
      publicPath: process.env.VUE_APP_PUBLICPATH,
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {},
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
.main_w {
  background-color: #f5f7fa;
  width: 100%;
  padding-bottom: 1rem;
}
</style>